import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import cookie from '@/utils/cookie' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 添加 路径， 取消验证，并在 shiro 中添加 修改
const whiteList = ['/login', '/tvBoardTotal'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = cookie.getCookie('userid')
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        const roleMemuList = store.state.user.roleMemuList
        const reg = /([/][^/]+)$/
        const path = to.path.match(reg)[1].replace('/', '')
        for (const item of roleMemuList) {
          if (item.path === path) {
            await store.dispatch('user/setRouteId', item.menuId)
          }
        }
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const params = { userId: store.state.user.userid }
          const { roles } = await store.dispatch('user/getInfo', params)
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', 'admin')
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // const roleMemuList = store.state.user.roleMemuList
          const roleMemuList = [
            {
              'title': '报警信息查询',
              'updateUserName': '管理员',
              'menuParentId': '0',
              'component': 'views/MacAlarmInformationHistory',
              'insertUserName': '管理员',
              'redirect': null,
              'sortOrder': 69,
              'icon': null,
              'menuId': '180000',
              'path': '/MacAlarmInformationHistory',
              'insertDate': '2020-03-06 15:44:58',
              'alwaysShow': 0,
              'updateDate': '2020-03-06 15:44:58',
              'insertUserId': '10001',
              'updateUserId': '10001',
              'version': 1,
              'englishTitle': 'Equipment Alarm Inquiry',
              'id': null
            }
            // ,
            // {
            //     "title":"设备台账",
            //     "updateUserName":"管理员",
            //     "menuParentId":"140000",
            //     "component":"views/MacRepParameter",
            //     "insertUserName":"管理员",
            //     "redirect":"",
            //     "sortOrder":89,
            //     "icon":"",
            //     "menuId":"140601",
            //     "path":"MacRepParameter",
            //     "insertDate":"2021-01-25 16:09:00",
            //     "alwaysShow":0,
            //     "updateDate":"2021-01-25 16:09:00",
            //     "insertUserId":"10001",
            //     "updateUserId":"10001",
            //     "version":1,
            //     "englishTitle":"moratin",
            //     "id":null
            // }
          ]
          const reg = /([/][^/]+)$/
          const path = to.path.match(reg)[1].replace('/', '')
          for (const item of roleMemuList) {
            if (item.path === path) {
              await store.dispatch('user/setRouteId', item.menuId)
            }
          }

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js